import { identity, option } from "fp-ts";
import { pipe } from "fp-ts/lib/pipeable";

export const simpleFold = <T>(optionToFold: option.None | option.Some<T>) => pipe(
    optionToFold,
    option.fold(
        () => undefined,
        identity.flatten
    )
);